const asAbsolute = (...paths) => `/${paths.join('/')}`;

export { asAbsolute };
